import { createRouter, createWebHistory } from "@ionic/vue-router";
import { Browser } from "@capacitor/browser";
import Login from "@/pages/login/index.vue";
import Callback from "@/pages/callback/index.vue";
import Resources from "../pages/resources/index.vue";
import ResourceBookmarks from "../pages/resources/bookmark.vue";
import ResourceSearch from "../pages/resources/resource-search.vue";
import ResourcesSessions from "../pages/resources/sessions.vue";
import StudentGuide from "../pages/student-guide.vue";
import WhatsNext from "../pages/whats-next.vue";
import TermsOfUse from "../pages/terms-of-use.vue";
import PrivacyPolicy from "../pages/privacy-policy.vue";
import { createAuthGuard, useAuth0 } from "@auth0/auth0-vue";
import VideoPage from "../pages/video/_video.vue";
// import SignUp from "../pages/sign-up.vue";
import { auth0 } from "@/utils/auth0";
import { storeLoginPath, clearLoginPathObj } from "@/utils/redirect-uri";
import store from "@/store";
import Forms from "../pages/forms/_name.vue";
import GicSignup from "../pages/forms/gic-signup.vue";
import GpcSignup from "../pages/forms/gpc-signup.vue";
import AccessDenied from "../pages/access-denied.vue";
import UrlPage from "../pages/url.vue";

const routes = [
  {
    path: "/",
    component: Login,
  },
  {
    path: "/login",
    component: Login,
  },
  // {
  //   path: "/sign-up",
  //   component: SignUp,
  // },
  {
    path: "/home",
    redirect: "/resources",
  },
  {
    path: "/resources",
    component: Resources,
  },
  {
    path: "/resources/sessions/mylist",
    component: ResourceBookmarks,
  },
  {
    path: "/resources/sessions",
    component: ResourcesSessions,
  },
  {
    path: "/resources/sessions/search",
    component: ResourceSearch,
  },
  {
    path: "/terms-of-use",
    component: TermsOfUse,
  },
  {
    path: "/privacy-policy",
    component: PrivacyPolicy,
  },
  {
    path: "/resources/video/:video",
    component: VideoPage,
  },
  {
    path: "/student-guide",
    component: StudentGuide,
  },
  {
    path: "/whats-next",
    component: WhatsNext,
  },
  {
    path: "/forms/gic-signup",
    component: GicSignup,
  },
  {
    path: "/forms/gpc-signup",
    component: GpcSignup,
  },
  {
    path: "/forms/:name",
    component: Forms,
  },
  {
    path: "/callback",
    component: Callback,
  },
  {
    path: "/access-denied",
    component: AccessDenied,
  },
  {
    path: "/url",
    component: UrlPage,
  },
];

routes.forEach((route) => {
  // these are for web only
  if (process.env.VUE_APP_NODE_ENV !== "local") {
    const excludeGuardPaths = [
      "/",
      "/access-denied",
      "/login",
      // "/sign-up",
      "/privacy-policy",
      "/terms-of-use",
      "/student-guide",
      "/callback",
    ];
    if (!excludeGuardPaths.includes(route.path)) {
      route.beforeEnter = createAuthGuard({
        redirectLoginOptions: {
          appState: {
            returnTo: window.location.pathname, // here
          },
        },
      });
    }
  }
});

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from) => {
  const excludeGuardPaths = [
    "/",
    "/access-denied",
    // "/sign-up",
    "/privacy-policy",
    "/terms-of-use",
    "/student-guide",
    "/callback",
  ];
  if (process.env.VUE_APP_NODE_ENV === "local") {
    if (!localStorage.getItem("token") && to.path !== "/login")
      return { path: "/login" };
    return;
  }

  if (excludeGuardPaths.includes(to.path)) return;

  console.log("from.path", from.path);
  console.log("to.path", to.path);
  if (from.path === "/" && to.path !== "/login") {
    storeLoginPath(window.location.href);
  }

  const loginBefore = sessionStorage.getItem("loginBefore");
  if (loginBefore === "true" && from.path === "/login") {
    clearLoginPathObj();
  }

  try {
    // token is needed for all APIs
    const token = await auth0.getAccessTokenSilently({
      cacheMode: "cache-only",
    });
    store.commit("user/setToken", token);
  } catch (err) {
    console.error("Error in get Access Token Silently");
    console.error(err);
    if (err.error === "login_required") {
      auth0.logout({
        logoutParams: {
          returnTo: createLogoutUri(
            process.env.VUE_APP_PACKAGE_ID,
            process.env.VUE_APP_AUTH0_DOMAIN
          ),
        },
        openUrl: async (url) =>
          await Browser.open({
            url,
            windowName: "_self",
          }),
      });
    }
    if (error.message.includes("nvalid authorization code")) {
      console.error("Detected invalid authorization code. Refreshing page...");
      window.location.reload();
    }
  }
});

export default router;
